<template>
<!-- <LoginPassPhraseInput v-if="pageIndex == 0" :vModel="vModel"> </LoginPassPhraseInput> -->
<div v-if="pageIndex == 0">
    <div class="main-header">
        <div class="container">
            <h2 class="main-header-text">Security Phrase</h2>
        </div>
    </div>
    <div class="main-section mgt-40">
        <div class="container">
            <div class="main-card">
                <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
                <div class="phrase-content security-phrase">
                    <div class="content-inner">
                        <div class="sp-section">
                            <h6>Anti-Phishing </h6>
                            <p>To better protect you, we're implementing an additional security verification before logging into your account. </p>
                        </div>
                        <div class="sp-section">
                            <h6>Security Phrase </h6>
                            <p>Enter a phrase only you would know (30 character limit). This phrase will appear on the login screen once the Username is entered.</p>
                        </div>
                        <div class="sp-section form-group">
                            <label>Insert your phrase here :</label>
                            <input autocomplete="off" id="passphrase" v-model="vModel.passphrase" v-validate="'required|min:8|max:30'" data-vv-as='Phrase' v-drag-disable='' :class="{'input': true, 'is-danger': errors.has('passphrase'),'form-control' : true  }" type="text" placeholder="Insert Your Phrase" name="passphrase" v-only-uppercase />
                            <div v-show="errors.has('passphrase')" class="help is-danger">
                                {{ errors.first('passphrase') }}</div>
                        </div>
                        <div class="sp-section">
                            <h6>Note : </h6>
                            <p> Please enter a phrase that is easily remembered. DO NOT <br> insert your User ID or Password as Security Phrase. </p>
                        </div>
                        <div class="button-wrap ">
                            <button class="btn btn-next" type="button" @click="onPassPhraseSubmit">Next</button>
                        </div>
                    </div>
                    <!--end Content inner-->
                </div>
                <!--end content-->
            </div>
        </div>
    </div>
</div>
<PassPhraseConfirmation v-else-if="pageIndex == 1" :vModel="vModel"> </PassPhraseConfirmation>
</template>

<script>
import authservice from "../../services/authservice";
// import welcome from "../../shared/Welcome.vue";
import commonService from "../../services/common";
import LoginPassPhraseInput from "./loginPassPhraseIInput.vue"
import PassPhraseConfirmation from "./loginPassPhraseConfirmation.vue"
export default {
    name: "login",
    components: {
        // welcome,
        LoginPassPhraseInput,
        PassPhraseConfirmation
    },

    created() {
        if (this.pageIndex == null) {
            this.pageIndex = 0;
        }
    },
    provide() {
        return {
            $validator: this.$validator,
        }
    },

    data() {
        return {
            windowAlive: null,
            vModel: {
                passphrase: null,
            },
            isProcessing: false,
            pageIndex: 0,

        };
    },
    methods: {

        onPassPhraseConfirm: function () {
            var self = this;
            if (self.isProcessing)
                return;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isProcessing = true;

                    self.$http.post('v2/account/passphrase/update', {
                        PassPhrase: self.vModel.passphrase

                    }).then(response => {
                            self.$toastr("success", "Security Phrase updated successfully");

                            self.isProcessing = false;
                            commonService.setStorage("IsPassPhraseRequired", "false");
                            self.$router.push("/dashboard");

                        },
                        error => {
                            self.isProcessing = false;
                        });

                }
            });
        },
        onPassPhraseCancel: function () {
            var self = this;
            self.pageIndex = 0;
        },

        onPassPhraseSubmit: function () {
            debugger;
            var self = this;
            self.$validator.validate("passphrase", self.vModel.passphrase).then(result => {
                if (result)
                    self.pageIndex = 1;
            });

        }
    }
};
</script>
